<template>
  <div>
    <div>
      <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" :model="formData" class="demo-form-inline" label-width="90px" size="mini">
          <!-- <div class="searchBox inpBox"> -->
            <div class="formItemBox">
             <el-form-item label="所在仓库:" prop="organizationId">
                <el-select  v-model="formData.organizationId"  placeholder="">
                  <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantCode" :key="val.relTenantCode"></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="入库单号:">
              <el-input
                class="ipt"
                v-model="formData.instockNo"
                placeholder="请输入入库单号"
                size="mini"
                style="width: 150px"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="车号:">
              <el-input v-model="formData.instockPlateNumber" placeholder="请输入车号"></el-input>
            </el-form-item>
            <el-form-item label="进仓单号:">
              <el-input v-model="formData.inWarehouseNo" placeholder="请输入进仓单号"></el-input>
            </el-form-item>
            <el-form-item label="货物类型:" prop="productType">
              <el-select  v-model="formData.productType"   placeholder="请选择">
                <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no" :key="item.item_no"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产地:" prop="steelMillName">
              <el-input  placeholder="" v-model="formData.steelMillName"></el-input>
            </el-form-item>
            <el-form-item label="规格:" prop="specification">
              <el-input  placeholder="" v-model="formData.specification"></el-input>
            </el-form-item>
            <el-form-item label="材质:" prop="model">
              <el-input  placeholder="" v-model="formData.model"></el-input>
            </el-form-item>
            <el-form-item label="确认时间:" >
              <div style="display: flex;">
                <el-date-picker v-model="formData.confirmTimeStart" type="datetime" placeholder="选择确认时间"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                -
                <el-date-picker v-model="formData.confirmTimeEnd" placeholder="选择确认时间" type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="到货方式:">
            <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
              <el-option
                v-for="(item, index) in arrivalMethodData"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
              </el-select>
          </el-form-item>
               </div>
        <!-- </div> -->
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                 <el-form-item >
                  <el-button type="primary"  @click="exportFn" >导出</el-button>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">总件数：<span class="red">{{totalNumber}}</span>件</p>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">总重量：<span class="red">{{totalAllWeight}}</span>吨</p>
                </el-form-item>
            </div>
        </el-form>
      </div>
      <div :style="{height:h}">
          <el-table
          border
          center
          bordersize="mini"
          :data="tableData"
          height="100%"
          style="width:100%"
          size="mini"
          highlight-current-row
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
          @selection-change="selectGoods"
          >
            <el-table-column type="selection" align="center" width="40"></el-table-column>
            <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="confirmTime" label="确认时间" width="180" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="inWarehouseNo" label="进仓单号" width="220" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" width="200" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="220" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" width="100" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="poundWeight" label="过磅净重（吨）" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="poundWeightTime" label="过磅净重时间" width="180" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" width="180" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" width="220" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="150" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="180" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="200" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="150" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center" width="150"></el-table-column>

          </el-table>
      </div>
      <div class="pags" >
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageInfo.pageNo"
            :page-size="pageInfo.pageSize"
            :page-sizes="[10,20,30,40,50]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { socAlreadyEnteredZy, getSocAlreadyEnteredZyWeightNumber } from '@/api/soc-stock-cosco'
import DonMessage from '@/utils/message'
import { dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  props: {
    productTypes: {
      type: Array,
      required: true
    },
    warehouseList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      formData: {
        organizationId: '',
        inWarehouseNo: '',
        instockNo: '',
        instockPlateNumber: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        confirmTimeStart: '',
        confirmTimeEnd: '',
        arrivalMethod: ''
      },
      tableData: [],
      HZData: [],
      h: 500,
      xuanzhongArr: null,
      daoruMark: false,
      isDisable1: false,
      selectListId: [],
      selectList: [],
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      totalAllWeight: 0,
      totalNumber: 0
    }
  },
  methods: {
    // 总吨数
    getSocAlreadyEnteredZyWeightNumber () {
      getSocAlreadyEnteredZyWeightNumber({
        organizationId: this.formData.organizationId,
        inWarehouseNo: this.formData.inWarehouseNo,
        instockNo: this.formData.instockNo,
        instockPlateNumber: this.formData.instockPlateNumber,
        productType: this.formData.productType,
        steelMillName: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model,
        confirmTimeStart: this.formData.confirmTimeStart,
        confirmTimeEnd: this.formData.confirmTimeEnd,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        arrivalMethod: this.formData.arrivalMethod,
        customerTaxId: localStorage.getItem('tenantTaxpayerNumber')
      }).then(res => {
        console.log(res)
        if (res.length != 0) {
          this.totalAllWeight = res.totalAllWeight
          this.totalNumber = res.totalNumber
        } else {
          this.totalAllWeight = 0
          this.totalNumber = 0
        }
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 列表查询
    JfgetConfirmedExpLists () {
      socAlreadyEnteredZy(
        {
          organizationId: this.formData.organizationId,
          inWarehouseNo: this.formData.inWarehouseNo,
          instockNo: this.formData.instockNo,
          instockPlateNumber: this.formData.instockPlateNumber,
          productType: this.formData.productType,
          steelMillName: this.formData.steelMillName,
          specification: this.formData.specification,
          model: this.formData.model,
          confirmTimeStart: this.formData.confirmTimeStart,
          confirmTimeEnd: this.formData.confirmTimeEnd,
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          arrivalMethod: this.formData.arrivalMethod,
          customerTaxId: localStorage.getItem('tenantTaxpayerNumber')
        }
      )
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.inDetailId) // id数组
        arry = Array.from(new Set(arry)) // 去重
        this.selectListId = arry.join(',') // 获取全部货物id
      })
    },
    handleClicktab (tab, event) {
      console.log(tab, event)
      // this.getControlAuditLists()
    },
    searchFn () {
      this.JfgetConfirmedExpLists()
      this.getSocAlreadyEnteredZyWeightNumber()
    },
    resetForm () {
      this.formData.organizationId = this.warehouseList[0].relTenantCode
      this.formData.inWarehouseNo = ''
      this.formData.instockNo = ''
      this.formData.instockPlateNumber = ''
      this.formData.productType = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.confirmTimeStart = ''
      this.formData.confirmTimeEnd = ''
      this.formData.arrivalMethod = ''
      this.searchFn()
    },
    exportFn () {
      exportExcel(
        this.global.wmsAccessName + '/instockThread/exportSocAlreadyEnteredZy',
        { ...this.formData },
        '进仓记录信息表'
      )
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetConfirmedExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetConfirmedExpLists()
    }
  },
  created () {
    if (this.warehouseList.length > 0) {
      this.$set(this.formData, 'organizationId', this.warehouseList[0].relTenantCode)
    }
    this.searchFn()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.searchFn()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 215 + 'px'
  }
}
</script>

<style>

</style>
